import * as React from 'react';
import { SingleColumnLayout } from '../designSystem/layouts/SingleColumnLayout';
import { H2 } from '../designSystem/typography/Heading';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { P } from '../designSystem/typography/Body';
import { Flex } from '../designSystem/compositeComponents/FlexHelpers';
import { PageHeader } from '../designSystem/PageHeader';


export default function PrivacyPolicyPage(): JSX.Element 
{
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivityOverview']}>
        
            <SingleColumnLayout
                noDivider

                contentContainer={
                    <>
                    <PageHeader headerText='Cookies og Privatlivspolitik' headerStyle='primary-black'/>
                    <Flex flexDirection='column' gap={64}>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Generelt</H2>
                            <P>
                            AMORG ApS (CVR. Nr.: 43511750) herefter (”vi”, ”os”, vores”) med tilhørende hjemmeside www.amorg.dk er et dansk selskab med hjemstedsadresse på Kronprinsessegade 6,1, 1306 København K i Danmark.
                            <br /><br />
                            Vi værner om dine personoplysninger og følger til enhver tid gældende lovgivning for at beskytte dine personlige oplysninger. Vores hjemmeside www.amorg.dk er en webportal, der benyttes og anvendes af kunder.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Personoplysninger</H2>
                            <P>
                            Vi benytter kun dine/jeres personoplysninger, som du har givet accept til, for at vi kan opfylde vores aftale med dig som kunde. De typiske oplysninger vi har behov for, er flg.:
                            <ul>
                                <li>Fornavn og efternavn</li>
                                <li>Virksomhedsadresse</li>
                                <li>E-mailadresse</li>
                                <li>Telefonnummer</li>
                                <li>Navn på kontaktperson og tilhørende emailadresse</li>
                            </ul>
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Anvendelse af dine personoplysninger</H2>
                            <P>
                            Vi indsamler data for at kunne opfylde vores aftale med dig om levering af de ydelser som vi leverer. Vi anvender ikke dine personoplysninger til andet formål end at kunne yde den nødvendige service til dig som kunde.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Besøg på vores side</H2>
                            <P>
                            Når du benytter vores side, anvender vi cookies for at siden kan fungere. AMORG ApS indsamler udelukkende tekniske cookies. Tekniske cookies benyttes ifm. indtastning af brugernavn og password. Tekniske cookies har ingen betydning for din privatsfære, da de ikke registrer, hvad du søger efter på andre sider.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Kommunikation</H2>
                            <P>
                            Som kunde eller interesseret i vores løsninger, kan du kontakte os via:
                            <ul>
                                <li>Mail: <a href="mailto:kontakt@amorg.dk">kontakt@amorg.dk</a></li>
                                <li>Telefon: +45 2372 7333</li>
                            </ul>
                            Herigennem vil vi behandle dine personoplysninger, så vi kan indgå i en dialog med dig fx svare på spørgsmål om vores ydelser. Vi behandler kun den information, som du giver os i forbindelse med vores kommunikation. Vores hjemmel til at behandle disse personoplysninger er databeskyttelsesforordningens artikel 6, stk. 1 litra f. Vi sletter vores kommunikation med dig når det står klart om du ønsker vores ydelser eller ej. Skulle der i et særligt tilfælde opstå et behov for at opbevare dine personoplysninger i længere tid, så vil dette kunne være tilfældet.
                            <br /><br />
                            Vi har behov for at kommunikere med vores kunder, så vi sikrer os, at ydelsen leveres korrekt. Herigennem kan vi behandle oplysninger om navn, adresse, ydelser, særlige aftaler, betalingsinformationer og lignende.
                            <br /><br />
                            Hjemlen til at behandle disse personoplysninger er databeskyttelsesforordningens artikel 6, stk. 1 litra b.
                            <br /><br />
                            Når ydelsen er leveret og eventuelle udestående er afsluttede, så vil vi umiddelbart herefter slette personoplysningerne.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Bogføring</H2>
                            <P>
                            Vi skal gemme alle regnskabsbilag jf. bogføringsloven. Det betyder, at vi gemmer fakturaer og lignende bilag til brug for regnskabsføring. Heraf kan der fremgå almindelige personoplysninger som navn, adresse, ydelsesbeskrivelse.
                            <br /><br />
                            Vores hjemmel til at behandle personoplysninger til bogføringen er databeskyttelsesforordningens artikel 6, stk.1 litra.
                            <br /><br />
                            Vi opbevarer disse oplysninger i minimum 5 år efter at indeværende regnskabsår er afsluttet.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                        <H2>Databehandlere</H2>
                        <P>
                        Få kan klare alt selv, og det samme gælder os. Vi har derfor samarbejdspartnere, samt benytter os af leverandører, hvoraf nogle kan være databehandlere. Eksterne leverandører kan f.eks. levere systemer til at organisere vores arbejde, services, rådgivning, IT-hosting eller markedsføring.
                        <br /><br />
Hos AMORG ApS benytter vi databehandlere som lagrer data på servere som overholder gældende retningslinjer. Vi arbejder løbende med disse for at sikre at dine personoplysninger er sikre og ikke kommer til kundskab hos uvedkommende, misbruges eller behandles i strid med de gældende regler.
<br /><br />
Vi benytter hos AMORG ApS følgende samarbejdspartnere hvor dine data opbevares:
<ul>
    <li>Microsoft Azure</li>
</ul>
                        </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Videregivelse af personoplysninger</H2>
                            <P>
                            Vi videregiver som udgangspunkt ikke dine personoplysninger til tredjemand. Vi kan dog vælge at dele dine oplysninger hvis det er nødvendigt for at vi kan opfylde vores aftale eller hvis vi er forpligtet til det efter aftale med offentlige- og retslige myndigheder, herunder hvis vi skal indberette oplysninger til det offentlige.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Tredjelandeoverførsler</H2>
                            <P>
                            Vi benytter som udgangspunkt databehandlere i EU/EØS, eller som opbevarer data i EU/EØS.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Beskyttelse og sikkerhed</H2>
                            <P>
                                AMORG ApS har truffet passende tekniske og organisatoriske foranstaltninger med henblik på at beskytte dine oplysninger mod f.eks. tab, manipulering eller uvedkommende adgang.
                                <br/><br/>
                                AMORG ApS sletter Personoplysninger i overensstemmelse med gældende lovgivning. Det betyder f.eks., at AMORG ApS sletter oplysningerne, når der ikke længere er et formål med at behandle de pågældende personoplysninger.
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Ændring, sletning og gennemgang af dine personoplysninger</H2>
                            <P>
                                AMORG ApS opbevarer dine oplysninger så længe lovgivningen foreskriver.<br />
                                Du har har ret til at få oplyst, hvilke oplysninger vi har om dig i forbindelse med en service vi har ydet. Hvis de oplysninger, vi har registreret om dig ikke er korrekte, kan du få dem rettet eller slettet.<br />
                                Anmodninger skal fremsendes per mail til <a href="mailto:kontakt@amorg.dk">kontakt@amorg.dk</a>.<br/>
                                Du har altid ret til at gøre indsigelse imod at vi anvender oplysninger, men det kan dog resultere i at vi ikke kan levere den fulde service til dig.<br/>
                            </P>
                        </Flex>

                        <Flex flexDirection='column' gap={4}>
                            <H2>Kontakt</H2>
                            <P>
                                Hvis du har spørgsmål til AMORG ApS behandling af personoplysningerne er du altid velkommen til at rette henvendelse til os.<br/><br/>
                                AMORG ApS<br/>
                                Kronprinsessegade 6,1<br/>
                                DK-1306 København K<br/>
                                E-mail: <a href="mailto:kontakt@amorg.dk">kontakt@amorg.dk</a><br/>
                                Tlf.: +45 2372 7333<br/>
                            </P>
                        </Flex>
                    </Flex>
                        
                    </>
                }
            />
        </ProtectedPageWrapper>

    );
}